import { Component, OnInit,Input } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';
import { TopicService } from '../../service/topic.service';
import { commonService } from '../../service/common.service';
import { ForumsService } from '../../service/forums.service';
@Component({
  selector: 'app-followers',
  templateUrl: './followers.component.html',
  styleUrls: ['./followers.component.css'],
  providers:[TopicService,ForumsService]
})
export class FollowersComponent implements OnInit {
  @Input() public options;
  userId:any;
  followerList:any;
  followerListCount:any;
  profileUrl:any;
  obj:any;
  isPostLoad=true;
  constructor(private forumsService:ForumsService,private _common:commonService,private global:Globals,private TopicService:TopicService,public router: Router,private route: ActivatedRoute) { 
    this.obj={};

  }

  ngOnInit() {

    this.userId=this.options.userId;
    this.profileUrl= this.global.profileUrl;
    this._common.profile.subscribe((data:any)=>{
      if(data!=null && Object.keys(data).length!=0){
        this.obj.userData = data;
      }else{
        this.obj.userData={};
        
      } 
   })

   this.route.params.subscribe((params: Params) => {
    if(params['id']){ 
     this.userId=this.userId;
     this.follower();
   }else{
    this.follower();
   }
  });

  }

  follower(){
    this.TopicService.getfollower({'puserId':this.userId,'userId':(this.obj.userData.id)?this.obj.userData.id:this.obj.userData.id}).subscribe((data : any)=>{
       this.isPostLoad=false;
      if(data.error==0){
         this.followerList = data.results.rows;
         this.followerListCount=data.results.count;
      }
      else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        //this.router.navigate(['/']);
        }
      }
      
    })
  }


  topicFollow(topicDetail){
    if(Object.keys(this.obj.userData).length == 0){ 
      this._common.setLoginBox(true);   
      return false;
    } 
    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    //console.log(obj);

    this.TopicService.saveFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount +=1;
      topicDetail.followerCount +=1;
      }
    },(error:HttpErrorResponse)=>{
      //this.msg="internal server error!";
  
    })

    
   }
   topicUnFollow(topicDetail){

    if(Object.keys(this.obj.userData).length == 0){ 
      this._common.setLoginBox(true);   
      return false;
    } 
    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    this.TopicService.saveunFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount -=1;
      topicDetail.followerCount -=1;
      }
    },(error:HttpErrorResponse)=>{
     // this.msg="internal server error!";
  
    })
   }

  customdecode(data){   
    return encodeURI(btoa(data));
   }

   userFollower(user){
    if(Object.keys(this.obj.userData).length == 0){ 
      this._common.setLoginBox(true); 
      return false;
    } 

    let obj={}
    obj['f_userid']=(this.obj.userData.id)?this.obj.userData.id:0;
    obj['t_userid']=user.id;
    this.forumsService.userFollower(obj).subscribe((data:any)=>{
          if(data.error==0){
        
            if(data.result=='add'){
              if(parseInt(user.follower) == null){
                user.follower=0;
              }
              if(parseInt(user.ismyfollow) == null){
                user.ismyfollow=1;
              }
              
              user.follower = parseInt(user.follower) + 1;
              user.ismyfollow=1;
              //console.log(user);
  
            }else if(data.result=='sub'){
              if(parseInt(user.follower) == null){
                user.follower=0;
              }
              if(parseInt(user.ismyfollow) == null){
                user.ismyfollow=0;
              }
              
              user.follower = parseInt(user.follower) - 1;
              user.ismyfollow=0;
              //console.log(user);
            }
            
          }
    },(error:HttpErrorResponse)=>{
     // this.msg="internal server error!";
    })
  
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/followers/followers.component.ts